/**
 * TanStack Query hooks for `budget-pacing-alert-burn-rate-forecasting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	budgetPacingAlertBurnRateForecastingQueryKeys,
	type CreateBudgetPacingAlertBurnRateForecastingBody,
	type ListBudgetPacingAlertBurnRateForecastingResponse,
	type BudgetPacingAlertBurnRateForecastingRow,
} from "./api";

export function useBudgetPacingAlertBurnRateForecastingList(): UseQueryResult<ListBudgetPacingAlertBurnRateForecastingResponse, Error> {
	return useQuery({
		queryKey: budgetPacingAlertBurnRateForecastingQueryKeys.list(),
		queryFn: list,
	});
}

export function useBudgetPacingAlertBurnRateForecastingCreate(): UseMutationResult<BudgetPacingAlertBurnRateForecastingRow, Error, CreateBudgetPacingAlertBurnRateForecastingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: budgetPacingAlertBurnRateForecastingQueryKeys.all });
		},
	});
}

export function useBudgetPacingAlertBurnRateForecastingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: budgetPacingAlertBurnRateForecastingQueryKeys.all });
		},
	});
}
